import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import { messages } from './languages'

const DEFAULT_LANGUAGE = 'pt-BR'
const SUPPORTED_LANGUAGES = ['pt', 'en', 'es']

const normalizeLanguage = language => {
  const normalizedLanguage = String(language || '').trim()

  if (normalizedLanguage === 'pt-BR') {
    return 'pt'
  }

  return SUPPORTED_LANGUAGES.includes(normalizedLanguage) ? normalizedLanguage : 'pt'
}

let savedLanguage = normalizeLanguage(localStorage.getItem('i18nextLng') || DEFAULT_LANGUAGE)
localStorage.setItem('i18nextLng', savedLanguage)

i18n.use(LanguageDetector).init({
  debug: false,
  defaultNS: 'translations',
  fallbackLng: 'pt',
  ns: ['translations'],
  resources: messages,
  lng: savedLanguage,
  supportedLngs: SUPPORTED_LANGUAGES,
  load: 'languageOnly',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
  detection: {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage'],
    lookupLocalStorage: 'i18nextLng',
  },
  keySeparator: '.',
  nsSeparator: ':',
  initImmediate: true,
})

export const initializeLanguageFromBackend = async () => {
  try {
    const api = (await import('../services/api')).default

    try {
      const { data: userData } = await api.get('/users/me/language')
      const userLanguage = normalizeLanguage(userData?.language)

      if (SUPPORTED_LANGUAGES.includes(userLanguage)) {
        localStorage.setItem('i18nextLng', userLanguage)
        if (i18n.language !== userLanguage) {
          await i18n.changeLanguage(userLanguage)
        }
        return userLanguage
      }
    } catch (err) {
      console.error('Erro ao buscar idioma do usuário:', err)
    }

    try {
      const { data: systemData } = await api.get('/settings/system-default-language')
      const systemLanguage = normalizeLanguage(systemData?.language || DEFAULT_LANGUAGE)

      if (SUPPORTED_LANGUAGES.includes(systemLanguage)) {
        localStorage.setItem('i18nextLng', systemLanguage)
        if (i18n.language !== systemLanguage) {
          await i18n.changeLanguage(systemLanguage)
        }
        return systemLanguage
      }
    } catch (err) {
      console.error('Erro ao buscar idioma padrão do sistema:', err)
    }
  } catch (err) {
    console.error('Erro ao inicializar idioma do backend:', err)
  }

  const finalLanguage = normalizeLanguage(localStorage.getItem('i18nextLng') || DEFAULT_LANGUAGE)

  localStorage.setItem('i18nextLng', finalLanguage)
  if (i18n.language !== finalLanguage) {
    await i18n.changeLanguage(finalLanguage)
  }

  return finalLanguage
}

if (savedLanguage && i18n.language !== savedLanguage) {
  i18n.changeLanguage(savedLanguage).catch(() => {
    console.warn('Nao foi possivel aplicar o idioma salvo:', savedLanguage)
  })
}

export { i18n }
